import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { DIALOG_CONFIG, DialogConfig, DialogRef } from "@ngneat/dialog";
import { ButtonComponent } from "../../button/button.component";

export type SuccessDialogData =
  | {
      bodyTranslateText: string;
      buttonTranslateText: string;
    }
  | undefined;

@Component({
  selector: "app-success-dialog",
  templateUrl: "./success-dialog.component.html",
  styleUrls: ["./success-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent, TranslocoModule],
})
export class SuccessDialogComponent<DataType extends SuccessDialogData>
  implements OnInit
{
  bodyTranslateText = "dialog.new-version-available";
  buttonTranslateText = "button.update";

  readonly dialogRef = inject(DialogRef);
  protected readonly dialogConfig =
    inject<DialogConfig<DataType>>(DIALOG_CONFIG);

  ngOnInit(): void {
    const { data } = this.dialogConfig;

    this.setDialogTexts(data);
  }

  private setDialogTexts(data: DataType): void {
    if (!data) return;
    const { bodyTranslateText, buttonTranslateText } = data;

    if (bodyTranslateText) {
      this.bodyTranslateText = bodyTranslateText;
    }

    if (buttonTranslateText) {
      this.buttonTranslateText = buttonTranslateText;
    }
  }

  acceptAction() {
    this.dialogRef.close(true);
  }
}
